import Browser          from '../Constants/Browser';
import DeviceType       from '../Constants/DeviceType';
import OperatingSystem  from '../Constants/OperatingSystem';
import IUserDevice      from '../Interfaces/IUserDevice';

import isVersionAtLeast from './isVersionAtLeast';

const WINDOWS_7_VERSION = 'NT 6.1';
const WINDOWS_8_VERSION = 'NT 6.2';

class UserDevice implements IUserDevice {
    public browser: Browser;
    public browserVersion: string;
    public os: OperatingSystem;
    public osVersion: string;
    public deviceType: DeviceType;

    public get isChrome(): boolean {
        return this.browser === Browser.CHROME;
    }

    public get isFirefox(): boolean {
        return this.browser === Browser.FIREFOX;
    }

    public get isSafari(): boolean {
        return this.browser === Browser.SAFARI;
    }

    public get isEdge(): boolean {
        return this.browser === Browser.EDGE;
    }

    public get isInternetExplorer(): boolean {
        return this.browser === Browser.INTERNET_EXPLORER;
    }

    public get isOpera(): boolean {
        return this.browser === Browser.OPERA;
    }

    public get isOsx(): boolean {
        return this.os === OperatingSystem.OSX;
    }

    public get isWindows(): boolean {
        return this.os === OperatingSystem.WINDOWS;
    }

    public get isLinux(): boolean {
        return this.os === OperatingSystem.LINUX;
    }

    public get isDesktop(): boolean {
        return this.deviceType === DeviceType.DESKTOP;
    }

    public get isMobile(): boolean {
        return this.deviceType === DeviceType.MOBILE;
    }

    public get isTv(): boolean {
        return this.deviceType === DeviceType.TV;
    }

    public get isConsole(): boolean {
        return this.deviceType === DeviceType.CONSOLE;
    }

    public get isDongle(): boolean {
        return this.deviceType === DeviceType.DONGLE;
    }

    public get isOldWindows(): boolean {
        return this.isWindows && [WINDOWS_7_VERSION, WINDOWS_8_VERSION].includes(this.osVersion);
    }

    public get isInternetExplorer11OnOldWindows(): boolean {
        return this.isOldWindows && this.isInternetExplorer && this.isBrowserVersionLessThan('12');
    }

    public isBrowserVersionAtLeast(version: string|number): boolean {
        return isVersionAtLeast(this.browserVersion, version);
    }

    public isOsVersionAtLeast(version: string|number): boolean {
        return isVersionAtLeast(this.osVersion, version);
    }

    public isBrowserVersionLessThan(version: string|number): boolean {
        return !this.isBrowserVersionAtLeast(version);
    }

    public isOsVersionLessThan(version: string|number): boolean {
        return !this.isOsVersionAtLeast(version);
    }
}

export default UserDevice;